<script setup lang="ts">
import VHeading from '@shared/typography/VHeading/VHeading.vue';

const props = defineProps<{
  title: string;
}>();
</script>

<template>
  <div class="min-w-0">
    <VHeading :level="2" appearance="sm" class="mb-2">{{ props.title }}</VHeading>
    <div class="space-y-0.5 text-sm text-grey-700">
      <slot></slot>
    </div>
  </div>
</template>
